<template>
    <div>
        <div class="columns is-multiline">
            <BambooCredentials
            :details="details"
            :credsModal="credsModal"
            @updateCompany="updateDetail"
            @closeModal="credsModal=false"
            />
            <div class="column is-full">
                <b-field label="Bamboo payments">
                    <b-switch
                    v-model="details.bambooChannel"
                    @input="updateDetail">
                    </b-switch>
                </b-field>
                <a @click="credsModal=false;credsModal=true">Editar las credenciales de bamboo.</a>
            </div>
            

            <div class="column is-full">
                <b-field label="MercadoPago"
                message="Controla si MercadoPago esta disponible para los usuarios a la hora de pagar">
                    <b-switch
                        v-if="details.mpAuthorized"
                        v-model="details.mpChannel"
                        @input="updateDetail">
                    </b-switch>
                    <VinculateMP v-else :details="details" :mpAuthUrl="mpAuthUrl"/>
                </b-field>
            </div>
            <div class="column is-full">
                <b-field label="Transferencia de banco">
                    <b-switch
                    v-model="details.transferChannel"
                    @input="updateDetail">
                    </b-switch>
                </b-field>
            </div>
            <div class="column is-full">
                <b-field label="Medios de pago presenciales">
                    <b-switch
                    v-model="details.cashChannel"
                    @input="updateDetail">
                    </b-switch>
                </b-field>
            </div>
            <div class="column is-full">
                <p v-if="payments" class="title is-size-4">Canales de pago directos con verificacion manual.</p>
                <p v-else>Agrega un canal de pago directo con verificacion manual.</p>
            </div>
            <div v-for="channel in payments" :key="channel.id" class="column is-full">
                <article class="media">
                    <div class="media-content">
                        <div class="columns is-multiline m-t-10">
                            <div class="column is-half">
                                <b-field label="Titulo" label-position="on-border">
                                    <b-input
                                    @input="updateChannel(channel)"
                                    v-model="channel.title"
                                    required>
                                    </b-input>
                                </b-field>
                            </div>
                            <div class="column is-half">
                                <b-field label="Tipo" label-position="on-border">
                                    <b-select
                                    @input="updateChannel(channel)"
                                    v-model="channel.method"
                                    expanded
                                    required>
                                        <option value="transfer">Transferencia bancaria</option>
                                        <option value="cash">Pagos presenciales/efectivo</option>
                                    </b-select>
                                </b-field>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-one-third">
                                <b-field label="Linea de datos 1" label-position="on-border">
                                    <b-input
                                    @input="updateChannel(channel)"
                                    v-model="channel.dato1">
                                    </b-input>
                                </b-field>
                            </div>
                            <div class="column is-one-third">
                                <b-field label="Linea de datos 2" label-position="on-border">
                                    <b-input
                                    @input="updateChannel(channel)"
                                    v-model="channel.dato2">
                                    </b-input>
                                </b-field>
                            </div>
                            <div class="column is-one-third">
                                <b-field label="Linea de datos 3" label-position="on-border">
                                    <b-input
                                    @input="updateChannel(channel)"
                                    v-model="channel.dato3">
                                    </b-input>
                                </b-field>
                            </div>
                        </div>
                        <div class="columns is-multiline">
                        
                            <div class="column is-half">
                                <b-field label="Linea de datos 4" label-position="on-border">
                                    <b-input
                                    expanded
                                    @input="updateChannel(channel)"
                                    v-model="channel.dato4">
                                    </b-input>
                                </b-field>
                            </div>
                            <div class="column is-half">
                                <b-field label="Linea de datos 5" label-position="on-border">
                                    <b-input
                                    expanded
                                    @input="updateChannel(channel)"
                                    v-model="channel.dato5">
                                    </b-input>
                                </b-field>
                            </div>
                        
                        </div>         
                    </div>
                    <div class="media-right">
                        <a class="has-text-danger" @click="deleteChannel(channel)">
                            <b-icon icon="trash" size="is-small"></b-icon>
                            Delete
                        </a>
                    </div>
                </article>
                <hr/>
            </div>
            <div class="column is-full has-text-centered">
                <b-button
                type="is-primary"
                rounded
                @click="createModal=true">
                    <b-icon icon="plus" size="is-small"></b-icon>
                    Agregar canal.
                </b-button>
            </div>
        </div>

        <b-modal :active.sync="createModal" scroll="keep">
            <div class="modal-card" style="width: auto">
                <div class="modal-card-body">
                    <div class="columns is-multiline">
                        <div class="column is-half">
                            <b-field label="Titulo">
                                <b-input 
                                required
                                v-model="newChannel.title">
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-half">
                            <b-field label="Tipo">
                                <b-select
                                expanded
                                v-model="newChannel.method"
                                required>
                                    <option value="transfer">Transferencia bancaria</option>
                                    <option value="cash">Pagos presenciales/efectivo</option>
                                </b-select>
                            </b-field>
                        </div>
                        <div class="column is-full">
                            <b-field label="Linea de datos 1">
                                <b-input
                                v-model="newChannel.dato1">
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-full">
                            <b-field label="Linea de datos 2">
                                <b-input
                                v-model="newChannel.dato2">
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-full">
                            <b-field label="Linea de datos 3">
                                <b-input
                                v-model="newChannel.dato3">
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-full">
                            <b-field label="Linea de datos 4">
                                <b-input
                                v-model="newChannel.dato4">
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-full">
                            <b-field label="Linea de datos 5">
                                <b-input
                                v-model="newChannel.dato5">
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-full has-text-centered">
                            <b-button
                            type="is-primary"
                            rounded
                            :loading="loadingSave"
                            @click="createPayment">
                                <b-icon icon="save" size="is-small"></b-icon>
                                Guardar canal de pagos.
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { getHandler, postHandler, patchHandler, deleteHandler, debounce } from '../../../../services/http'
import VinculateMP from "./VinculateMP.vue"
import BambooCredentials from "./BambooCredentials"

export default {
    components:{
        VinculateMP,
        BambooCredentials
    },
    props:{
        paymentListUrl:{
            type:String,
            default:""
        },
        paymentCreateUrl:{
            type:String,
            default:""
        },
        details:{
            type:Object,
            default:new Object({})
        },
        loading:{
            type:Boolean,
            default:false,
        },
        companyEndpoint:{
            type:String,
            default:""
        },
        mpAuthUrl:{
            type:String,
            default:""
        },
        ppCredDetails:{
            type:String,
            default:""
        },
        ppCredCreate:{
            type:String,
            default:""
        }

    },
    data(){
        return{
            payments:[],
            newChannel:{
                method:"transfer",
                title:"",

            },
            createModal:false,
            loadingSave:false,
            credsModal:false
        }
    },
    methods:{
        emitUpdateCompanyDetails(){
            this.$emit("fetchDetails")
        },
        async fetchPayments(){
            this.payments = await getHandler(this.paymentListUrl, {error:false, success:false})
        },
        async createPayment(){
            var msgE = {
                resource:"notify",
                text:"Algo a salido mal! vuelve a intentarlo",
            }
            var msgS = {
                resource:"notify",
                text:"Nuevo canal de pago creado con exito."
            }
            this.loadingSave = true
            var resp = await postHandler(
                this.paymentCreateUrl, 
                this.newChannel, 
                {
                    error:msgE,
                    success:msgS
                }
            )
            this.loadingSave = false
            this.newChannel={
                method:"transfer",
                title:"",   
            }
            this.fetchPayments()

            },

        async deleteChannel(item){
            var msgS = {
                resource:"notify",
                text:"Canal eliminado"
            }
            var msgE = {
                resource: "notify",
                text:"Algo a salido mal! vuelve a intentarlo",
            }
            var resp = await deleteHandler(item.getEditUrl, {error:msgE, success:msgS})
            this.fetchPayments()
        },
        updateChannel: debounce(
            async function(item){
                var msgS = {
                    resource:"notify",
                    text:"Canal editado con exito!"
                }
                var msgE = {
                    resource: "notify",
                    text:"Algo a salido mal! vuelve a intentarlo",
                }
                var resp = await patchHandler(item.getEditUrl, item, {error:msgE, success:msgS})
                this.fetchPayments()
            },
            1000
        ),

        async updateDetail(){
            var msgS = {
                resource:"notify",
                text:"Modificacion realizada con exito"
            }
            var mesgE = {
                resource: "notify",
                text:"Algo a salido mal! vuelve a intentarlo",
            }
            var resp = await patchHandler(
                this.companyEndpoint,
                this.details,
                {
                    error:mesgE,
                    success:msgS
                }
            )

        }
    },
    created(){
        this.fetchPayments()
    }
}
</script>

<style lang="scss" scoped>
.media-content{
    height: auto;
}
</style>